<section class="bg-grey">
  <h1 class="section-title mdg-blue">
    Register with <span class="mdg-green">medigi</span>
  </h1>
  <p class="section-copy">
    <span class="callout mdg-blue">Register now</span> to connect, negotiate and
    list/purchase product. The secure process is quick and hassle free
  </p>
  <div class="card-container">
    <div class="cards bg-white box-shadow">
      <h3 class="mdg-blue">Pharmacy</h3>
      <p>
        <span class="mdg-blue">Register now</span> to purchase full-dated,
        short-dated, and even compounded products directly from a community of
        pharmaceutical manufacturers
      </p>
      <a class="white pharmacy-register-cta" href="/registration/buyer"
        ><button class="bg-mdg-blue white">Register Now</button></a
      >
    </div>
    <div class="cards bg-white box-shadow">
      <h3 class="mdg-blue">Manufacturers</h3>
      <p>
        <span class="mdg-blue">Register now</span> to connect, negotiate and
        list product for Pharmacies. The secure process is quick and hassle free
      </p>
      <a class="white pharmacy-register-cta" href="/registration/seller"
        ><button class="bg-mdg-blue white">Register Now</button></a
      >
    </div>
  </div>
  <h2 class="mdg-blue">Questions?</h2>
  <h3>
    Contact us at <span class="mdg-blue">844-733-5633</span> or
    <span class="mdg-blue">info"&#64;medigi.com</span>
  </h3>
</section>
